class ScrollToPageTopDirective {
    constructor($window, $timeout) {
        this.restrict = 'A';
        this.$window = $window;
        this.$timeout = $timeout;
        this.margin = 0;
        this.leftPanelBottomY = null;
        this.max = 2500;
        this.element = null;
        this.attrs = null;
        this.relativeElement = null;
        this.scrollOffset = 0;
        this.scroll = () => {};
    }

    get leftPanelBottom() {
        return this.leftPanelBottomY ? this.leftPanelBottomY : document.getElementById('left-panel-bottom');
    }

    get maxMargin() {
        return this.relativeElement.offsetHeight - this.element.offsetHeight - this.scrollOffset;
    }

    watchForDOMNodeChanges(targetNode) {
        const config = {attributes: false, childList: true, subtree: true};
        const callback = (mutationsList, observer) => {
            this.$timeout(() => {
                this.scroll();
            }, 1000);
        }
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }

    link(scope, element, attrs, controllers) {
        const container = element[0];

        this.element = element[0];
        this.attrs = attrs;

        if (this.attrs.scrollOffset) {
            this.scrollOffset = parseInt(this.attrs.scrollOffset);
        }

        if (attrs.rel) {
            this.relativeElement = document.getElementById(attrs.rel);
            if (!this.relativeElement) {
                const DomNodeInsertedEvent = (event) => {
                    if (event.target.id === 'checkout-items-component') {
                        this.relativeElement = event.target;
                        document.removeEventListener('DOMNodeInserted', DomNodeInsertedEvent);
                        this.watchForDOMNodeChanges(this.relativeElement);
                    }
                }
                document.addEventListener('DOMNodeInserted', DomNodeInsertedEvent);
            } else {
                this.watchForDOMNodeChanges(this.relativeElement);
            }
        }

        this.watchForDOMNodeChanges(this.element);

        this.scroll = () => {
            if (window.matchMedia("(max-width: 1000px)").matches) {
                if (this.margin > 0) {
                    this.margin = 0;
                    container.style.marginTop = '';
                }

                return;
            }

            const bounding = container.getBoundingClientRect();

            this.margin = this.margin + (-1 * bounding.y);

            let max = this.relativeElement ? this.maxMargin : 2500;

            if (this.leftPanelBottom) {
                max = this.leftPanelBottom.offsetTop - 815;
            }

            this.margin = Math.min(max, this.margin);

            if (this.margin < 0) {
                this.margin = 0;
            }

            container.style.marginTop = `${this.margin}px`;
        };

        const onChange = (event) => {
            this.scroll();
        }

        angular.element(this.$window).on('resize', onChange);
        angular.element(this.$window).on('scroll', onChange);

        scope.$on('$destroy', () => {
            angular.element(this.$window).off('resize', onChange);
            angular.element(this.$window).off('scroll', onChange);
        });
    }

    static directiveFactory($window, $timeout) {
        'ngInject';
        return new ScrollToPageTopDirective($window, $timeout);
    }
}

export default ScrollToPageTopDirective;
